import EntityType from "@mapmycustomers/shared/enum/EntityType";
import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/map/types";
import { isNotEmptyString } from "@mapmycustomers/shared/util/assert";

const canSyncEntityEmails = (entity: EntitiesSupportedByEmailFeature) => {
  switch (entity.entity) {
    case EntityType.COMPANY:
      return isNotEmptyString(entity.website) || isNotEmptyString(entity.email);
    case EntityType.PERSON:
      return isNotEmptyString(entity.email);
  }
};

export default canSyncEntityEmails;
